import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-auction-card',
  templateUrl: './auction-card.component.html',
  styleUrls: ['./auction-card.component.scss'],
})
export class AuctionCardComponent {
  @Input('item') item: Record<any, any> = {};
  @Input('auctionType') auctionType: 'current' | 'future' | 'initialLive' | '' =
    '';

  public env: string = environment.forntend_url;
  public baseUrl: string = environment.imgBaseUrl;
  public auctionEntity: 'Individual' | 'Individual batch' | 'Bulk' | null =
    null;
  public imageList: any[] = [];
  public newImg: any[] = [];
  constructor(private router: Router) {}

  ngOnInit() {}

  ngAfterViewInit() {
    switch (this.item['entity_type']) {
      case 'individual_batch':
        this.auctionEntity = 'Individual batch';
        break;
      case 'individual':
        this.auctionEntity = 'Individual';
        break;
      case 'group':
        this.auctionEntity = 'Bulk';
        break;
    }

    this.imageList = this.item['ProductImage']
      ? this.item?.['ProductImage']
      : [];

    this.imageList.forEach((item: Record<any, any>, index: number) => {
      if (item.hasOwnProperty('image')) {
        if (this.item['entity_type'] === 'individual_batch') {
          item[
            'presigned_url'
          ] = `${environment.auctionBaseUrl}${item['image']}`;
        } else {
          item['presigned_url'] = `${environment.imgBaseUrl}${item['image']}`;
        }
      }

      if (this.imageList.length == 1) {
        this.newImg.push({
          img: item['presigned_url'],
          class: 'col-12',
        });
      } else if (this.imageList.length == 2) {
        this.newImg.push({
          img: item['presigned_url'],
          class: 'col-6',
        });
      } else if (this.imageList.length == 3) {
        if (index === this.imageList.length - 1) {
          this.newImg.push({
            img: item['presigned_url'],
            class: 'col-12',
          });
        } else {
          this.newImg.push({
            img: item['presigned_url'],
            class: 'col-6',
          });
        }
      } else if (this.imageList.length == 4) {
        this.newImg.push({
          img: item['presigned_url'],
          class: 'col-6',
        });
      } else if (this.imageList.length == 5) {
        if (index == this.imageList.length - 1) {
          this.newImg.push({
            img: item['presigned_url'],
            class: 'col-8',
          });
        } else {
          this.newImg.push({
            img: item['presigned_url'],
            class: 'col-4',
          });
        }
      } else if (this.imageList.length == 6) {
        this.newImg.push({
          img: item['presigned_url'],
          class: 'col-4',
        });
      }
    });
  }
}
